import {Grid} from '@material-ui/core';
import React from 'react';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';
import {AllstateCardV2} from 'Shared/components/AllstateCardV2';
import {CardFieldV2} from 'Shared/components/CardFieldV2';

export type PremiumPaymentSummaryProps = {
  eisFlag: boolean;
  status?: string;
  billPremium?: number;
  modePremium?: number;
  lastPayment?: number;
  paymentDate?: Date;
};

export const PremiumPaymentSummary = (props: PremiumPaymentSummaryProps) => {
  const {eisFlag, status, modePremium, billPremium, lastPayment, paymentDate} = props;
  return (
    <AllstateCardV2 title="Premium Payment Summary">
      <Grid
        container
        spacing={3}
        justifyContent="flex-start"
        style={{
          padding: '1rem',
          width: '100%',
          margin: 0,
        }}
      >
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Status" value={status} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Mode Premium" value={toMoneyValue(modePremium)} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Bill Premium" value={toMoneyValue(billPremium)} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Last Payment" value={toMoneyValue(lastPayment)} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Payment Date" value={toFormattedDateAsUTC(paymentDate)} />
        </Grid>
      </Grid>
    </AllstateCardV2>
  );
};
